import { render, staticRenderFns } from "./managelist.vue?vue&type=template&id=fef1ea1e&scoped=true&"
import script from "./managelist.vue?vue&type=script&lang=js&"
export * from "./managelist.vue?vue&type=script&lang=js&"
import style0 from "./managelist.vue?vue&type=style&index=0&id=fef1ea1e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef1ea1e",
  null
  
)

export default component.exports